/**
 * BLOCK: Megamneu Nav Menu Block.
 */
import { __ } from '@wordpress/i18n'
import { disabledBlocks, i18n } from 'cartzillagb'
import { BlogPostsIcon } from '~cartzillagb/icons'


/**
 * Internal dependencies
 */
import save from './save'
import edit from './edit'

const schema = {
    className: {
        type: 'string',
    },

    megaMenuSlug : {
        type: 'string',
        'default': ''
    },

}


export const name = 'czgb/megamenu-nav-menu'

export const settings = {
    title: __( 'Megamenu Nav Menu', i18n ),
    description: __( 'A Megamenu Nav Menu block given to a large panel of content which is displayed below a menu item when the user clicks or hovers over the menu item', i18n ),
    icon: BlogPostsIcon,
    example: {},
    category: 'cartzillagb',
    keywords: [
        __( 'Megamenu Nav Menu', i18n ),
        __( 'CartzillaGb', i18n ),
    ],
    supports: {
        inserter: ! disabledBlocks.includes( name ), // Hide if disabled.
    },
    attributes: schema,

    edit,
    save,

    // CartzillaGB modules.
    // modules: {
    //     'advanced-responsive': true,
    // },
}